import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightbulb04 = function Lightbulb04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.5 22h5M10 10h4m-2 0v6m3-.6736c2.3649-1.1235 4-3.534 4-6.3264 0-3.866-3.134-7-7-7S5 5.134 5 9c0 2.7924 1.635 5.2029 4 6.3264V16c0 .9319 0 1.3978.1522 1.7654.203.49.5924.8794 1.0824 1.0824C10.6022 19 11.0681 19 12 19s1.3978 0 1.7654-.1522c.49-.203.8794-.5924 1.0824-1.0824C15 17.3978 15 16.9319 15 16z"
    })
  }));
};
export default Lightbulb04;